import { ChangeEvent } from "react"
import { useAppDispatch } from "../../../../store/hooks"
import { changeFontStyle } from "../../../../store/model";

interface CheckListInputProp {
  properyItem: GeometricShape,
  options: string[]
  // propertyName: string,
  // properyDisplayName: string,
  // injection?: ActionCreatorWithPayload<{
  //   id: string;
  //   propertyValue: string;
  //   propertyName: string;
  // }>,
}
const CheckListInput = ({ properyItem, options }: CheckListInputProp) => {

  const dispatch = useAppDispatch();

  return (
    <div>
      <p>
        {options.map((mode) => {
          return (
            <label key={mode}>
              {mode}:
              <input
                type="checkbox"
                name="mode"
                defaultChecked={properyItem.type === "text" && properyItem.fontStyle.search(mode) >= 0}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  dispatch(changeFontStyle({ shape: properyItem, option: mode }));
                }}
              />
            </label>
          )
        }
        )}
      </p>
    </div>
  )
}



export default CheckListInput